import {
  Converter,
  ConverterService,
  Occ,
  PRODUCT_NORMALIZER
} from '@spartacus/core'
import { Injectable } from '@angular/core'
import { Order } from '@spartacus/order/root'
import { ORDER_ENTRY_PROMOTIONS_NORMALIZER, OrderEntry, PromotionResult } from '@spartacus/cart/base/root'

@Injectable({
  providedIn: 'root'
})
export class OccMbPaymentOrderNormalizer implements Converter<{ order: Occ.Order; status: string }, Order> {

  constructor (protected converterService: ConverterService) {}

  convert (source: { order: Occ.Order; status: string }, target?: Order) {
    if (target === undefined) {
      target = { ...source?.order, returnStatus: source?.status } as Order
    }
    if (source?.order?.entries) {
      target.entries = source?.order?.entries.map(entry =>
        this.convertMbOrderEntry(entry, source?.order?.code, source?.order?.appliedProductPromotions))
    }
    return target
  }

  private convertMbOrderEntry (source?: Occ.OrderEntry, code?: string, promotions?: PromotionResult[]) {
    return {
      ...source,
      entries: this.convertChildEntries(source),
      product: this.converterService.convert(source?.product, PRODUCT_NORMALIZER),
      orderCode: code,
      promotions: this.converterService.convert({ item: source, promotions: promotions },
        ORDER_ENTRY_PROMOTIONS_NORMALIZER
      ),
    } as OrderEntry
  }

  private convertChildEntries (source?: Occ.OrderEntry) {
    return source?.entries?.map(entry => ({
      ...entry,
      product: this.converterService.convert(entry?.product, PRODUCT_NORMALIZER)
    }))
  }
}
